import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import TicketsManager from "../../components/TicketsManager";
import LegacyTicketsManager from "../../components/LegacyTicketsManager";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import toastError from "../../errors/toastError";

import { isModernChatLayout, normalizeChatLayoutMode } from "../../helpers/chatLayoutMode";

import TicketsLegacyShell from "./TicketsLegacyShell";
import TicketsTailwickShell from "./TicketsTailwickShell";
import TicketsWelcome from "./TicketsWelcome";

function Chat() {
	const { ticketId } = useParams();
	const { user } = useContext(AuthContext);

	const [legacyTicketsManager, setLegacyTicketsManager] = useState(false);

	useEffect(() => {
		const fetchSession = async () => {
			try {
				const { data } = await api.get("/settings");

				const legacyTicketsManagerSetting = data.find(
					(s) => s.key === "legacyTicketsManager"
				);

				if (
					legacyTicketsManagerSetting &&
					legacyTicketsManagerSetting.value === "enabled"
				) {
					setLegacyTicketsManager(true);
				}
			} catch (err) {
				toastError(err);
			}
		};
		fetchSession();
	}, []);

	const useTailwickLayout = isModernChatLayout(user?.chatLayoutMode);

	const listPanel = legacyTicketsManager ? (
		<LegacyTicketsManager tailwickLayout={useTailwickLayout} />
	) : (
		<TicketsManager tailwickLayout={useTailwickLayout} />
	);

	const welcomePanel = <TicketsWelcome tailwickLayout={useTailwickLayout} />;
	const Shell = useTailwickLayout ? TicketsTailwickShell : TicketsLegacyShell;

	return (
		<Shell
			key={normalizeChatLayoutMode(user?.chatLayoutMode)}
			ticketId={ticketId}
			listPanel={listPanel}
			welcomePanel={welcomePanel}
		/>
	);
}

export default Chat;
